define('views/modules/profile/blocks/preferences-personal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // events
    'services/events/user-events',
    // views
    'views/parts/info-section',
    'views/modules/profile/edit/preferences-edit-panel-personal',
    // templates
    'text!templates/modules/profile/blocks/preferences-personal.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // events
    UserEvents,
    // views
    VInfoSection,
    VPreferencesEditPanelPersonal,
    // templates
    TPreferencesPersonal
) {

    var VPreferencesPersonal = Backbone.Epoxy.View.extend({
        template: TPreferencesPersonal,

        initialize: function(opt) {
            _.extend(this, {
                group: opt.group
            });

            this.view = {
                info: new VInfoSection({
                    title: "Preferences",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-preferences-view",
                    buttonBottom: {
                        text: "Edit your preferences",
                        context: this,
                        callback: this.onEditPreferences
                    },
                })
            };

            this.listenTo(UserEvents, 'profile:update', this.onProfileUpdated);
        },

        render: function() {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext(
                    _.extend({
                        isSupervisor: User.getMainGroup().isSupervisor,
                    }, this.model.toJSON())
                ));

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        onEditPreferences: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.edit || (view.edit = new VPreferencesEditPanelPersonal({
                    model: this.model,
                    group: this.group
                }));
            this.trigger('panel:stack', panel);
        },

        onProfileUpdated: function() {
            this.when(this.model.fetch({ force: true })).then(function()  {
                this.render();
            }, this);
        }
    });

    return VPreferencesPersonal;
});

